import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {OrganisationService} from "../../../../services/organisation/organisation.service";
import {LANG_OPTIONS} from "../../../../lang.constants";
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import * as Cookies from "js-cookie";
import {ConstantsService as constants} from "../../../../services/constants/constants.service";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { WarningModalContentComponent } from 'src/app/lib/warning-modal/warning-modal.component';
import { PermissionsService } from '../../../../services/permissions/permissions.service';

@Component({
  selector: 'app-email-and-sms',
  templateUrl: './email-and-sms.component.pug',
  styleUrls: ['./email-and-sms.component.scss'],
  standalone: false
})
export class EmailAndSmsComponent implements OnInit, OnChanges {
  @Input() checkType: any;
  @Input() org: any;
  @Output() templateVariables = new EventEmitter();
  @Output() updatedTemplates = new EventEmitter();
  loading = true;
  showSMS = false;
  templates: {}[] = [];
  subjectLineCharLimit = 998;
  smsCharLimit = 1600;
  languages: any[] = [];
  orgLanguages = '';
  templateVars: any[] = [];
  selectedSmsIds: any[] = [];
  sendSms = false;
  logo = '';
  org_uid = Cookies.get(constants.ORG_COOKIE);
  bsModalRef!: BsModalRef;
  defaultTemplate = false;
  languageTemplateToRevert = '';
  selectedCheckType = '';

  constructor(private organisationService: OrganisationService,
    private modalService: BsModalService,
    private alertList: AlertBannerService,
    private permissions: PermissionsService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.org['brand_name']) {
      if (this.org['logo']) this.logo = this.org['logo'];
      this.getEmailTemplate();
    }
  }

  templateLanguage() {
    this.templates.forEach((val, index) => {
      let lang = val['language']
      val['send_sms'] = true;
      this.selectedSmsIds.push(true);
      let displayLanguage = LANG_OPTIONS.get(lang)
      this.languages.push(displayLanguage)
      if (index > 0) {
        this.orgLanguages += $localize` and ` + displayLanguage;
        return;
      }
      this.orgLanguages += displayLanguage;
    })
    let dataToSend = {
      "changed": false,
      "templates": this.templates
    }
    this.updatedTemplates.emit(dataToSend);
  }

  changedValue() {
    let dataToSend = {
      "changed": true,
      "templates": this.templates
    }
    this.updatedTemplates.emit(dataToSend);
  }

  showSMSTemplate(index, language, event: any) {
    this.selectedSmsIds[index] = event.currentTarget.checked;
    // @ts-ignore
    this.templates.find(template => template['language'] === language)['send_sms'] = event.currentTarget.checked;
    let dataToSend = {
      "changed": true,
      "templates": this.templates
    }
    this.updatedTemplates.emit(dataToSend)
  }

  getEmailTemplate() {
    this.selectedCheckType = this.checkType === constants.EXIT_CHECK ? 'exit_request' : 'pulse_request'
    this.organisationService.getTemplates(false, this.selectedCheckType, undefined).subscribe(response => {
      this.templates = response.data.templates;
      this.templateVars = response.data.variables;
      this.templateVariables.emit(this.templateVars);
      this.templateLanguage();
      this.setCharLimits();
      this.loading = false;
      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  setCharLimits() {
    if (this.templates) {
      if (this.templates.length > 1) {
        this.smsCharLimit = (this.smsCharLimit / this.templates.length) - 3;
      }
      if (this.templates.length > 1) {
        this.subjectLineCharLimit = (this.subjectLineCharLimit / this.templates.length) - 3;
      }
    }
  }
  getEmailTemplateToRevert(type: string, language: string, defaultTemplate: boolean) {
    let dbResponse: any[] = [];
    this.organisationService.getTemplate(defaultTemplate, language, this.selectedCheckType, type).subscribe(response => {
      dbResponse = response.data;
      dbResponse.forEach((val, index) => {
        if (val.language === language) {
          this.templates[index][type] = val[type];
        }
      })
      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
    }

  revertToDefault(type: string, language: string) {
    const initialState = {
      "title": $localize`Revert to default? `,
      "message": $localize`By reverting to the default, all changes will be lost.\n\nAre you sure you want to continue?  `
    };
    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered max-width-400', initialState
    });
    this.bsModalRef.content.selection.subscribe(res => {
      if (res === true) {
        this.getEmailTemplateToRevert(type, language, false);
      }
    })
  }
}
